import { isDefined } from "../../../../functions/is-defined.function";

export interface Entity {
  id: string | number;
}

export function isEntity(value: object): value is Entity {
  return isDefined((value as Entity)?.id);
}
